import React from "react";
import UserDropdown from "./UserDropdown";
import Button from "../../components/form/Button";
import { classNames } from "../../helpers/classNames";
import { changeTheme } from "../../services/ProfileService";
import { toast } from "react-toastify";

const AdminHeader = ({
  profile,
  setDarkMode,
  isDarkMode,
  fetchProfile = () => {},
}) => {
  const data = {
    image: profile?.image?.url,
    name: profile?.firstName
      ? profile?.firstName + " " + profile?.lastName
      : null,
    email: profile?.email,
  };

  const themeModeSetting = async (data) => {
    try {
      const res = await changeTheme({
        darkMode: data,
      });
      if (res?.status === 200) {
        fetchProfile();
      } else {
        toast.error(res?.data?.message || "Something went wrong");
      }
    } catch (err) {
      console.log(err);
      toast.error("Somthing went wrong !!!");
    }
  };

  return (
    <header className="sticky top-0 h-16 min-h-[64px] z-50 w-full flex items-center px-3 md:px-6 bg-orange-100 dark:bg-slate-800 shadow gap-4">
      <div className="relative ml-auto flex justify-end items-center gap-3 ">
        <div className="px-1">
          <Button
            buttonIcon={classNames(
              "fa-light",
              isDarkMode === "off" ? "fa-moon-stars" : "fa-sun-bright"
            )}
            buttonIconPosition={"left"}
            buttonClasses={
              "!p-0 aspect-square !bg-transparent justify-center !border-transparent !text-xl !text-black dark:!text-slate-400"
            }
            buttonFunction={() => {
              themeModeSetting(isDarkMode === "on" ? "off" : "on");
            }}
          />
        </div>
        <div className="relative">
          <UserDropdown role="admin" data={data} xPlacement={"bottomRight"} />
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;
